import React from 'react';
import { Text } from '@admitkard/ccl/Text';
import { ImgInfoCard } from '@admitkard/ccl/ImgInfoCard';
import { Button } from '@admitkard/ccl/Button';
import { theme } from '@admitkard/ccl/style';
import Link from 'next/link';

export interface MentorsDetailsInterface {
  firstName: string;
  profilePicUrl: string | null;
  _id: string;
  country: string | null;
  university: {
    _id: string;
    name: string | null;
  };
}

export interface MentorsDetailsListInterface {
  mentorsListing: MentorsDetailsInterface[];
}

export const AkMentorsListing: React.FunctionComponent<MentorsDetailsListInterface> = (props) => (
  <>
    <div className="connect-with-mentor__ak-mentors-list-wrapper">
      <div className="connect-with-mentor__ak-mentors__content">
        <Text
          variant='h3'
          className="connect-with-mentor__ak-mentors__content-title"
          display='block'
          weight='normal'>
          Mentors
        </Text>
        <Text
          variant='m'
          lightness={6}
          className="connect-with-mentor__ak-mentors__content-text"
          display='block'
          weight='normal'>
          AdmitKard offers you the opportunity to take the personalized assistance of mentors who
          will guide you throughout the entire journey of reaching to your dream college abroad.
          Your mentors, who themselves have been through the same phase as you, will help you in
          each small step from selecting a college to filing applications and further assistance.
        </Text>
      </div>

      <ul className="connect-with-mentor__ak-mentors-details-wrapper">
        {(props.mentorsListing.map(element => {
          const description: string[] = [];
          element.university && element.university.name && description.push(element.university.name);
          element.country && description.push(element.country);
          return <li key={element._id} className="connect-with-mentor__ak-mentors-details">
            <ImgInfoCard
              imgSrc={element.profilePicUrl || ''}
              heading={`${element.firstName || ''}`}
              description={`${description.join(', ')}`}
            />
          </li>;
        }))}
        <li className="connect-with-mentor__ak-mentors-details__empty-card"></li>
        <li className="connect-with-mentor__ak-mentors-details__empty-card"></li>
      </ul>
      <div className="connect-with-mentor__ak-mentors__see-more">
        <Link href='/mentors' as="/mentors">
          <Button
            color="secondary"
            size="large"
            variant="contained"
            className="connect-with-mentor__ak-mentors__see-more-btn"
          >
            Explore Mentors
          </Button>
        </Link>
      </div>
    </div>
    <style>{`
      .connect-with-mentor__ak-mentors-list-wrapper {
        overflow: hidden;
      }
      .connect-with-mentor__ak-mentors__content {
        padding: ${theme.spacingOld(6)};
        background: ${theme.palette.grey[0]};
      }
      .connect-with-mentor__ak-mentors__content-title {
        margin-top: 0;
        border-bottom: 1px solid;
        display: inline-block;
        padding-bottom: ${theme.spacingOld(4)};
      }
      .connect-with-mentor__ak-mentors-details-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0;
        margin: 0 -${theme.spacingOld(5)};
        margin-top: ${theme.spacingOld(6)};
      }
      .connect-with-mentor__ak-mentors-details-wrapper li {
        background: ${theme.palette.grey[0]};
        padding: ${theme.spacingOld(5)};
        margin: ${theme.spacingOld(6)} ${theme.spacingOld(4)};
        display: flex;
        flex-basis: 310px;
        flex-grow: 1;
        min-width: 45%;
      }
      .connect-with-mentor__ak-mentors__see-more {
        text-align: center;
        margin-top: ${theme.spacingOld(6)};
      }
      li.connect-with-mentor__ak-mentors-details__empty-card {
        margin: 0 ${theme.spacingOld(3)} 0;
        min-width: 45%;
        flex-basis: 310px;
        flex-grow: 1;
        padding: 0;
      }
      @media screen and (max-width: 768px) {
        .connect-with-mentor__ak-mentors-details-wrapper li {
          margin-top: ${theme.spacingOld(5)};
          margin-bottom: ${theme.spacingOld(5)};
        }
        li.connect-with-mentor__ak-mentors-details__empty-card {
          margin: 0 ${theme.spacingOld(3)} 0;
        }
      }
    `}</style>
  </>
);
